var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.label
      ? _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "input input--text", class: _vm.stateClasses }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentValue,
            expression: "currentValue"
          }
        ],
        style: { resize: _vm.resizeToggle },
        attrs: {
          maxlength: _vm.charLimit ? _vm.charLimit : 10000,
          "aria-labelledby": _vm.id,
          disabled: _vm.disabled,
          id: _vm.id,
          placeholder: _vm.disabled ? "Disabled" : _vm.placeholder
        },
        domProps: { value: _vm.currentValue },
        on: {
          keydown: _vm.keydownEvent,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.currentValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "input__underline",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      !_vm.valid
        ? _c(
            "div",
            { staticClass: "input__error", attrs: { role: "alert" } },
            [
              _c("icon", { attrs: { name: "error", size: "16px" } }),
              _vm._t("error")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "input__info" }, [_vm._t("info")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }